import * as React from "react";
import { styled } from "@mui/material";
import { PatientPopup } from "../uiControllers/patientPopup";
import { PatientColorMap } from "../../layout/patientColorMap";
import { useTranslate } from "../../hooks/useTranslate";
import { GenericButton } from "../uiControllers/genericButton";
import { onRtl } from "fe-web-components/rtl/rtlStyles";

//region [[ Styles ]]

const PartialResultsDisclaimerView = styled(PatientPopup)({
  "&.partial-results-disclaimer .patient-popup-container": {
    position: "absolute",
    padding: "20px",
  },
  "&.partial-results-disclaimer .close-button": {
    right: 0,
    ...onRtl({
      right: "auto",
      left: 0,
    }),
  },
});

const PopupTitle = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  fontWeight: 700,
  fontSize: "22px",
  lineHeight: "22px",
  color: PatientColorMap.Default,
  textAlign: "left",
  ...onRtl({
    textAlign: "right",
  }),
});

const PopupContent = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "flex-start",
  textAlign: "left",
  ...onRtl({
    textAlign: "right",
  }),
  marginTop: "19px",
  fontSize: "21px",
  marginBottom: "20px",
  fontWeight: 500,
});

const PupupButtons = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-between",
  width: "100%",
});

const GoBackButton = styled(GenericButton)({
  flexBasis: "50%",
  "&.generic-button": {
    margin: "10px 0",
    minWidth: "auto",
  },
  "&.generic-button:first-of-type": {
    marginRight: "7px",
    ...onRtl({
      marginRight: 0,
      marginLeft: "7px",
    }),
  },
});

const ContinueButton = styled(GoBackButton)({
  "&.generic-button": {
    background: PatientColorMap.PrimaryLight,
    color: PatientColorMap.Primary,
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PartialResultsDisclaimerProps {
  show: boolean;
  onClose: () => void;
  onContinue: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PartialResultsDisclaimer = ({
  ...props
}: PartialResultsDisclaimerProps) => {
  const { show, onClose, onContinue } = props;

  const { translate } = useTranslate();

  return (
    <PartialResultsDisclaimerView
      className={"partial-results-disclaimer"}
      open={show}
      onClose={onClose}
      slideDirection={"up"}
    >
      <PopupTitle>{translate("PARTIAL_RESULTS_TITLE")}</PopupTitle>
      <PopupContent>{translate("PARTIAL_RESULTS_NOTICE")}</PopupContent>
      <PupupButtons>
        <ContinueButton
          onClick={onContinue}
          label={translate("SKIP_QUESTIONS")}
        />
        <GoBackButton onClick={onClose} label={translate("GO_BACK")} />
      </PupupButtons>
    </PartialResultsDisclaimerView>
  );
};
